import React from 'react';
import { Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import '../assets/styles/CustomRadioGroup.css';

interface RadioOption {
  value: string | number;
  label: string;
  description?: string;
  disabled?: boolean;
}

interface CustomRadioGroupProps {
  options: RadioOption[];
  value?: string | number;
  onChange?: (e: RadioChangeEvent) => void;
  fontSize?: string;
  horizontal?: boolean;
  gap?: string;
  disabled?: boolean;
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  options,
  value,
  onChange,
  fontSize,
  horizontal = false,
  gap,
  disabled = false,
}) => {
  return (
    <Radio.Group
      value={value}
      onChange={onChange}
      style={{
        display: 'flex',
        flexDirection: horizontal ? 'row' : 'column',
        gap: horizontal ? gap : '10px',
      }}
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          value={option.value}
          disabled={disabled || option?.disabled || false}
          className={`custom-radio ${option.description ? 'has-description' : ''}`}
          style={{
            fontSize: fontSize || '14px',
            fontWeight: '400',
            color: option?.disabled
              ? 'var(--text-secondary)'
              : 'var(--text-primary)',
          }}
        >
          <div className='radio-content'>
            <div className='radio-title'>{option.label}</div>
            {option.description && (
              <div className='radio-desc'>{option.description}</div>
            )}
          </div>
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default CustomRadioGroup;
